"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GLOBAL_FETCH = typeof window !== 'undefined' && typeof window.fetch !== 'undefined' ? fetch.bind(window) : null;
exports.GLOBAL_WEB_SOCKET = typeof WebSocket !== 'undefined' ? WebSocket : null;